module.exports = __webpack_public_path__ + "static/media/edsansiro-ambientes-005.7dad4432.jpg";